import { AdminApiClient } from '@guiker/prop-rental-shared'
import { AuthLevel, generateBaseApiContext } from '@guiker/react-framework'

export * from './use-api-client'

export const {
  useContext: useAdminPropRentalContext,
  Context: AdminPropRentalContext,
  ContextProvider: AdminPropRentalContextProvider,
  NestedRouter: AdminPropRentalRouter,
} = generateBaseApiContext({
  authLevel: AuthLevel.ADMIN,
  apiClientGen: AdminApiClient,
})

export const { useContext: useAdminPropRentalIdNestedContext, NestedRouter: AdminPropRentalIdNestedRouter } =
  generateBaseApiContext({
    authLevel: AuthLevel.ADMIN,
    apiClientGen: AdminApiClient,
    cacheKey: ({ id }: { id: string }) => `readOnePropRental-${id}`,
    fetcher: (apiClient, { id }: { id: string }) => apiClient.readOnePropRental({ pathParams: { id } }),
  })
